
    var riot = require('riot')
    //src: starling/src/tags/perspectives-banner.html
riot.tag2('perspectives-banner',
  '<div class="info"> <h4 if="{pui.getPersistentPerspectiveCount() < 5}"> <span class="title">Viewing {pui.getPersistentPerspectiveCount() > 1 ? \'perspectives\' : \'perspective\'}</span> <perspectives-banner-item each="{pui.getPersistentPerspectives()}"></perspectives-banner-item> </h4> <h4 if="{pui.getPersistentPerspectiveCount() >= 5}"> Viewing <span class="perspective-counter" onclick="{this.openSidebar}"> {pui.getPersistentPerspectiveCount()} perspectives</span> </h4> <div class="muted">Changes to card titles and summaries will be local to this perspective.</div> </div> <div class="action"> <button onclick="{exitPerspective}">EXIT</button> </div>',
  '',
  'show="{showBanner()}"', function(opts) {
'use strict';

var _this = this;

var _perspectivesUi = require('lib/perspectives-ui');

var _util = require('lib/util');

var _opts = opts,
    canvas = _opts.canvas;

canvas.perspectiveBannerTag = this;

this.isHidden = _perspectivesUi.pui.getPerspectives().some(function (p) {
  return !p.pointNodeUUID;
});

this.exitPerspective = function (e) {
  for (var _iterator = _perspectivesUi.pui.getPersistentPerspectives(), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
    var _ref;

    if (_isArray) {
      if (_i >= _iterator.length) break;
      _ref = _iterator[_i++];
    } else {
      _i = _iterator.next();
      if (_i.done) break;
      _ref = _i.value;
    }

    var p = _ref;

    _perspectivesUi.pui.unsetActivePerspective(p);
  }

  _this.update();

  canvas.nodeTools.update();
  canvas.perspectivesListingTag.update();
};

this.showBanner = function () {
  return !_this.isHidden && _perspectivesUi.pui.getPersistentPerspectiveCount() > 0;
};

this.getPerspective = function () {
  return _perspectivesUi.pui.getActivePerspectives()[0];
};

this.setHidden = function (isHidden) {
  _this.isHidden = isHidden;
  _this.update();
};

this.openSidebar = function () {
  canvas.toolsSidebarTag.open();
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('perspectives-banner')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/perspectives-banner.html
// module id = 584
// module chunks = 0